import React, { useState } from "react"
import slugify from "slugify"

export const TabGroup = ({ children, controls, title, subtitle }) => {
  const [activeTab, setActiveTab] = useState(0)

  return (
    <div className="tab-group">
      <header className="section-header">
        <div className="section-header__text">
          <h2 className="section-header__title">{title}</h2>
          {subtitle ? (
            <div className="section-header__subtitle">{subtitle}</div>
          ) : null}
        </div>
        <div className="section-header__controls">
          <header>Filter By</header>
          <ul role="tablist">
            {controls.map((item, index) => {
              return (
                <li key={index}>
                  <button
                    className="toggle"
                    onClick={() => setActiveTab(index)}
                    id={`${slugify(title)}-tab-${index}`}
                    aria-controls={`${slugify(title)}-panel-${index}`}
                    aria-selected={activeTab === index ? "true" : "false"}
                    role="tab"
                  >
                    <div className="title--meta title--bold title--uppercase">
                      <div
                        className="toggle__indicator"
                        role="presentation"
                      ></div>
                      {item}
                    </div>
                  </button>
                </li>
              )
            })}
          </ul>
        </div>
      </header>
      {children.map((child, index) => {
        return (
          <Tab
            key={index}
            content={child}
            active={activeTab}
            index={index}
            id={slugify(title)}
          />
        )
      })}
    </div>
  )
}

const Tab = ({ content, active, index, id }) => {
  return (
    <div
      className="tab-group__tab"
      hidden={active !== index ? "hidden" : null}
      role="tabpanel"
      id={`${id}-panel-${index}`}
      aria-labelledby={`${id}-tab-${index}`}
    >
      {content}
    </div>
  )
}
